export default __webpack_public_path__ + "d79b2445275e07af4bdfbcd552c9d58c.svg";